/** Global snapshot picker — shared workspace control (all tabs). */

function fmtSnapshotTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
}

export default function SnapshotPicker({ snapshots, selectedSnapshotId, onSelectSnapshot, busy }) {
  const snaps = Array.isArray(snapshots) ? snapshots : [];
  const selected = selectedSnapshotId != null ? String(selectedSnapshotId) : "";
  const can = typeof onSelectSnapshot === "function" && snaps.length > 0;

  if (!can) {
    return (
      <span className="text-dim" style={{ fontSize: "12px" }}>
        Viewing: {snaps[0]?.takenAt ? `Latest (${fmtSnapshotTime(snaps[0].takenAt)})` : "Latest"}
      </span>
    );
  }

  return (
    <label className="text-secondary" style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "6px" }}>
      <span>Viewing:</span>
      <select
        value={selected || (snaps[0]?.snapshotId ? String(snaps[0].snapshotId) : "")}
        onChange={(e) => onSelectSnapshot?.(e.target.value)}
        disabled={busy}
        className="idwiz-snapshot-select rounded border border-white/10 bg-white/[0.04] px-2 py-1 text-[12px] disabled:opacity-50"
        style={{ color: "var(--text-primary)" }}
      >
        {snaps.map((s, idx) => (
          <option
            key={s.snapshotId || idx}
            value={String(s.snapshotId)}
            style={{ color: "var(--text-primary)", background: "var(--bg-elevated)" }}
          >
            {idx === 0 ? "Latest" : "Snapshot"} — {fmtSnapshotTime(s.takenAt)}
          </option>
        ))}
      </select>
    </label>
  );
}
